import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { Alert, Spin } from 'antd';
import BidPackageListComponent from '../../components/bid-packages/BidPackageListComponent';
import { RootState } from '../../modules';
import {
  BidPackage,
  deleteBidPackageAsync,
  getBidPackageListAsync,
} from '../../modules/bid-packages';
interface BidPackageBidListContainerProps {
  enterpriseId: string;
  projectId: string;
}
function BidPackageBidListContainer({
  match,
  history,
}: RouteComponentProps<BidPackageBidListContainerProps>) {
  const { enterpriseId, projectId } = match.params;
  const { data, loading, error } = useSelector(
    (state: RootState) => state.bidPackages.bidPackages,
  );
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      getBidPackageListAsync.request({
        enterpriseId,
        projectId,
        isBudgeting: 'false',
      }),
    );
  }, [dispatch, enterpriseId, projectId]);

  const moveToBidPackageCreatePage = () => {
    history.push(`bidPackagesBidding/create?isBudeting=false`);
  };
  const moveToBidPackageDetailPage = (bidPackageId: number) => {
    history.push(`bidPackagesBidding/${bidPackageId}?tab=1`);
  };

  const onDelete = (bidPackage: BidPackage) => {
    dispatch(
      deleteBidPackageAsync.request({ enterpriseId, projectId, bidPackage }),
    );
  };

  return (
    <>
      {loading && <Spin />}
      {error && (
        <Alert
          message={`${error.response?.data.message}`}
          type="error"
          showIcon
          closable
        />
      )}
      {data && (
        <BidPackageListComponent
          bidPackages={data}
          isBudgeting={false}
          moveToBidPackageCreatePage={moveToBidPackageCreatePage}
          moveToBidPackageDetailPage={moveToBidPackageDetailPage}
          onDelete={onDelete}
        />
      )}
    </>
  );
}

export default BidPackageBidListContainer;
